// src/hooks/useApolloEnrich.js
// Hook que invoca a edge function `enrich-companies-via-apollo` do Supabase.
//
// A edge function retorna:
//   {
//     mode: "dry_run" | "commit",
//     total: number,            // total de empresas processadas
//     matched: number,          // quantas encontraram correspondência no Apollo
//     not_matched: number,      // quantas não tiveram match
//     errors: number,           // falhas de chamada/commit
//     duration_ms: number,
//     results: [
//       { empresa_id, nome, status, apollo_id?, apollo_name?, match_strategy?, fields_changed?, error? }
//     ]
//   }
//
// status ∈ { "committed", "skipped", "no_match", "preview", "error" }

import { useState, useCallback } from 'react';
import { supabase } from '../supabaseClient';

export function useApolloEnrich() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const invoke = useCallback(async ({
    limit = 10,
    force_refresh = false,
    mode = 'commit',
    empresa_ids = null,
  } = {}) => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const body = { limit, force_refresh, mode };
      if (empresa_ids && empresa_ids.length > 0) body.empresa_ids = empresa_ids;

      const { data, error: fnErr } = await supabase.functions.invoke(
        'enrich-companies-via-apollo',
        { body }
      );
      if (fnErr) throw fnErr;
      if (data?.error) throw new Error(data.error);
      setResult(data);
    } catch (e) {
      console.error('[useApolloEnrich] error:', e);
      setError(e?.message ?? String(e));
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setError(null);
  }, []);

  return { invoke, loading, result, error, reset };
}
